import React, { useEffect, useCallback, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { Select, Spin } from "antd";
import axios from "axios";
import { API_PATH } from "../../components/const";
import { toast } from "react-toastify";
import Cropper from "react-easy-crop";

const ProfileCreate = () => {
  let history = useHistory();
  const [loader, setLoader] = useState(false);
  const [sendData, setSendData] = useState({
    phone: "+998751234567",
  });
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  const [imageSrc, setImageSrc] = useState(null);
  const [pic, setPic] = useState(null);
  const [offices, setOffices] = useState([]);
  const [officesz, setOfficesZ] = useState([]);
  const [branch, setBranch] = useState([]);
  const [departments, setDepartments] = useState([]);
  // const [roles, setRoles] = useState([])
  const [modes, setModes] = useState([]);
  const [parents, setParents] = useState([]);

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => setImageSrc(reader.result);
    }
  };

  // Crop qilishni boshqarish
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    console.log(croppedAreaPixels);
  }, []);
  const getParentBuilding = (val) => {
    axios
      .get(
        API_PATH +
          "company/" +
          localStorage.getItem("id") +
          "/branch/sections/all" +
          (val?.length > 0 ? "?search_str=" + val : ""),
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        setParents(res?.data);
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  // const getRoles = (val) => {
  //     axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/get_all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
  //         .then(res => {
  //             setRoles(res.data)
  //             console.log(res.data)
  //         })
  //         .catch(err => {
  //             toast.error("Ошибка")
  //
  //         })
  // }

  const getModes = (val) => {
    axios
      .get(
        API_PATH +
          "company/" +
          localStorage.getItem("id") +
          "/hr/employee_work_schedule_template/all" +
          (val?.length > 0 ? "?search_str=" + val : ""),
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        setModes(res.data);
        setSendData({
          ...sendData,
          employee_work_schedules_template_id: res.data[0]?.id,
        });
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  const bigData = new FormData();

  const sendAll = () => {
    setLoader(true);
    if (pic) {
      bigData.append("image", pic?.target?.files[0]);
    }
    if (sendData?.first_name) {
      bigData.append("first_name", sendData?.first_name);
    }
    if (sendData?.last_name) {
      bigData.append("last_name", sendData?.last_name);
    }
    if (sendData?.username) {
      bigData.append("username", sendData?.username);
    }
    if (sendData?.email) {
      bigData.append("email", sendData?.username + "@example.com");
    }
    if (sendData?.password) {
      bigData.append("password", sendData?.password);
    }
    if (sendData?.position) {
      bigData.append("position", sendData?.position);
    }
    if (sendData?.date_of_birth) {
      bigData.append("date_of_birth", sendData?.date_of_birth);
    }
    if (sendData?.middle_name) {
      bigData.append("middle_name", sendData?.middle_name);
    }
    if (sendData?.phone) {
      bigData.append("phone", sendData?.phone);
    }
    if (sendData?.building_id) {
      bigData.append("building_id", sendData?.building_id);
    }
    if (sendData?.department_id) {
      bigData.append("department_id", sendData?.department_id);
    }
    if (sendData?.gender) {
      bigData.append("gender", sendData?.gender);
    }
    if (sendData?.role_id) {
      bigData.append("role_id", sendData?.role_id);
    }
    if (sendData?.branch_id) {
      bigData.append("branch_id", sendData?.branch_id);
    }
    if (sendData?.employee_work_schedules_template_id) {
      bigData.append(
        "employee_work_schedules_template_id",
        sendData?.employee_work_schedules_template_id
      );
    }

    if (pic?.target?.files[0]) {
      axios
        .post(
          API_PATH +
            "user/company/" +
            localStorage.getItem("id") +
            "/create/user",
          bigData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          toast.success("Добавлено успешно");
          // setSendData({
          //     "first_name": "",
          //     "last_name": "",
          //     "username": "",
          //     "email": "",
          //     "password": "",
          //     "position": "",
          //     "date_of_birth": "",
          //     "middle_name": "",
          //     "phone": "",
          //     "gender": "",
          //     "building_id": "",
          //     "department_id": "",
          // })
          setLoader(false);

          history.push("/main/hr-admin/employees");
        })
        .catch((err) => {
          // const jsonString = JSON.stringify(err?.response?.data?.detail);
          // console.log(JSON.stringify(err?.response?.data?.detail))
          setLoader(false);

          toast.error(
            err?.response?.status +
              " " +
              JSON.stringify(err?.response?.data?.detail)
          );
          // err?.response?.data?.detail[0]?.loc[0]
        });
    } else {
      toast.error("Пожалуйста, выберите изображение");
      setLoader(false);
    }
  };

  const getDeps = (val) => {
    axios
      .get(
        API_PATH +
          "company/" +
          localStorage.getItem("id") +
          "/hr/department/all" +
          (val?.length > 0 ? "?search_str=" + val : ""),
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        setDepartments(res.data?.items);
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  const getBuilding = (val) => {
    axios
      .get(
        API_PATH +
          "company/" +
          localStorage.getItem("id") +
          "/branch/branch/all?hierarchy=3" +
          (val > 0 ? "&parent_id=" + val : ""),
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        setOffices(res.data);
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  const getBuildingZ = (val) => {
    axios
      .get(
        API_PATH +
          "company/" +
          localStorage.getItem("id") +
          "/building/all" +
          (val > 0 ? "&parent_id=" + val : ""),
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((res) => {
        setOfficesZ(res.data?.items);
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  const getBranch = (val) => {
    axios
      .get(API_PATH + "company/" + localStorage.getItem("id") + "/branch/", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((res) => {
        setBranch(res.data?.items);
      })
      .catch((err) => {
        toast.error("Ошибка");
      });
  };
  const [photo123, setphoto123] = useState("/img/addphoto.png");

  // const uploadImg = (event) => {
  //     setphoto123(URL.createObjectURL(event?.target?.files[0]));
  //     setPic(event?.target?.files[0].toString());
  // };
  const uploadImg = (event) => {
    setphoto123(URL.createObjectURL(event?.target?.files[0]));
    setPic(event);
  };
  useEffect(() => {
    getBuilding();
    getParentBuilding();
    // getRoles()
    getDeps();
    getBranch();
    getModes();
    getBuildingZ();
  }, []);

  return (
    <div className="profile-edit">
      <div className="progress-link">
        <Link to="/main/visitor-home">
          {" "}
          <img src="/icon/Icon1.svg" alt="." />
        </Link>
        <img src="/icon/arrowleft.svg" alt="." />
        <Link to="/main/hr-admin/employees">
          {" "}
          <span>Cотрудники</span>
        </Link>
        <img src="/icon/arrowleft.svg" alt="." />
      </div>

      <div className="profile-header">
        <h3 className="font-family-medium">Информация о новом сотруднике</h3>
        <div className="profile-header-box-update">
          <div className="row">
            <div className="col-md-2 text-center">
              <div className="userPhoto">
                <label htmlFor="userPhoto" id="img1">
                  {" "}
                  <img src={photo123} alt="" />
                </label>
                <input
                  type="file"
                  onChange={(e) => uploadImg(e)}
                  id="userPhoto"
                />
                <p className="font-family-bold">Фотография</p>
                {/*<p className="open-sans-semibold">{getText("photo")}</p>*/}
              </div>

              {/*<label htmlFor="useImg">*/}
              {/*    {*/}
              {/*        imageSrc === null ?   <img src="/img/addphoto.png" alt="."/> : ""*/}
              {/*    }*/}
              {/*</label>*/}
              {/*<input type="file" id="useImg" className="mt-4 d-none" accept="image/*" onChange={handleFileChange}/>*/}

              {/*{imageSrc && (*/}
              {/*    <div style={{position: "relative", width: 300, height: 300}}>*/}
              {/*        <Cropper*/}
              {/*            image={imageSrc}*/}
              {/*            crop={crop}*/}
              {/*            aspect={1} // Kvadrat uchun*/}
              {/*            onCropChange={setCrop}*/}
              {/*            // onZoomChange={setZoom}*/}
              {/*            onCropComplete={onCropComplete}*/}
              {/*        />*/}
              {/*    </div>*/}
              {/*)}*/}
              {/*{*/}
              {/*    imageSrc === null ?*/}
              {/*      ""*/}
              {/*        :*/}

              {/*        <div className="con-btn">*/}
              {/*            <button>Сохранять</button>*/}
              {/*            <button className="ml-8" onClick={() => setImageSrc(null)}>Редактировать</button>*/}
              {/*        </div>*/}
              {/*}*/}
            </div>
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-6">
                  <div className="inputs-box">
                    <label className="font-family-medium">Имя </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        setSendData({
                          ...sendData,
                          first_name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="inputs-box">
                    <label className="font-family-medium">Фамилия </label>
                    <input
                      type="text"
                      onChange={(e) =>
                        setSendData({ ...sendData, last_name: e.target.value })
                      }
                    />
                  </div>
                  {/*<div className="inputs-box">*/}
                  {/*    <label className="font-family-medium">Отчество </label>*/}
                  {/*    <input type="text" onChange={(e) => setSendData({*/}
                  {/*        ...sendData,*/}
                  {/*        middle_name: e.target.value*/}
                  {/*    })}/>*/}
                  {/*</div>*/}

                  <div className="inputs-box">
                    <label className="font-family-medium">Логин </label>
                    <input
                      onChange={(e) =>
                        setSendData({
                          ...sendData,
                          username: e.target.value,
                          email: e.target.value + "example@gmail.com",
                        })
                      }
                      type="text"
                    />
                  </div>
                  <div className="inputs-box">
                    <label className="font-family-medium">Парол </label>
                    <input
                      onChange={(e) =>
                        setSendData({ ...sendData, password: e.target.value })
                      }
                      type="text"
                    />
                  </div>
                  <div className="inputs-box for-select">
                    <label className="font-family-medium">Пол </label>
                    <FormControl>
                      <RadioGroup
                        row
                        onChange={(e) =>
                          setSendData({ ...sendData, gender: e.target.value })
                        }
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel
                          value="male"
                          control={<Radio />}
                          label="Мужской"
                        />
                        <FormControlLabel
                          value="female"
                          control={<Radio />}
                          label="Женский"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {/*<div className="inputs-box">*/}
                  {/*    <label className="font-family-medium">Номер телефона </label>*/}
                  {/*    <input*/}
                  {/*        value={sendData?.phone}*/}
                  {/*        onChange={(e) => setSendData({...sendData, phone: e.target.value})}*/}
                  {/*        type="text"/>*/}
                  {/*</div>*/}
                  {/*<div className="inputs-box">*/}
                  {/*    <label className="font-family-medium">Email</label>*/}
                  {/*    <input*/}
                  {/*        onChange={(e) => setSendData({...sendData, email: e.target.value})}*/}
                  {/*        type="text"/>*/}
                  {/*</div>*/}
                  {/*<div className="inputs-box">*/}
                  {/*    <label  className="font-family-medium">Возраст </label>*/}
                  {/*    <input type="text"  />*/}
                  {/*</div>*/}
                </div>
                <div className="col-md-6">
                  {/*<div className="inputs-box">*/}
                  {/*    <label className="font-family-medium">Дата рождения </label>*/}
                  {/*    <input type="date"*/}
                  {/*           onChange={(e) => setSendData({*/}
                  {/*               ...sendData,*/}
                  {/*               date_of_birth: e.target.value*/}
                  {/*           })}*/}
                  {/*    />*/}
                  {/*</div>*/}

                  <div className="inputs-box-2">
                    <label className="font-family-medium">
                      Раздел{" "}
                      <button className="font-family-medium  text-white">
                        <span
                          onClick={() =>
                            history.push("/main/hierarchy/company")
                          }
                        >
                          Добавить новое
                        </span>
                      </button>
                    </label>
                    <Select
                      showSearch
                      placeholder="Выберите раздел"
                      optionFilterProp="children"
                      className="w-100"
                      onSearch={getParentBuilding}
                      onChange={(e) => getBuilding(e)}
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={parents?.map((item) => {
                        return {
                          value: item.id,
                          label: item.id + " " + item?.branch_title,
                        };
                      })}
                    />
                  </div>
                  <div className="inputs-box-2">
                    <label className="font-family-medium">
                      Филиал{" "}
                      <button className="font-family-medium  text-white">
                        <span
                          onClick={() =>
                            history.push("/main/hierarchy/company")
                          }
                        >
                          Добавить новое
                        </span>
                      </button>
                    </label>
                    <Select
                      showSearch
                      placeholder="Выберите филиал"
                      optionFilterProp="children"
                      className="w-100"
                      onSearch={getBuilding}
                      onChange={(e) =>
                        setSendData({ ...sendData, branch_id: e })
                      }
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={offices?.map((item) => {
                        return {
                          value: item.id,
                          label: item.id + " " + item?.branch_title,
                        };
                      })}
                    />
                  </div>
                  <div className="inputs-box-2">
                    <label className="font-family-medium">
                      Здание
                      <button className="font-family-medium">
                        {/* somethuing in your eyes */}
                        {/*<span*/}
                        {/*    onClick={() => history.push("/main/hierarchy/company")}*/}
                        {/*>*/}
                        {/*     Добавить новое*/}
                        {/*</span>*/}
                      </button>
                    </label>
                    <Select
                      showSearch
                      placeholder="Выберите эдание"
                      optionFilterProp="children"
                      className="w-100"
                      onSearch={getBuildingZ}
                      onChange={(e) =>
                        setSendData({ ...sendData, building_id: e })
                      }
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={officesz?.map((item) => {
                        return {
                          value: item.id,
                          label: item.id + " " + item?.name,
                        };
                      })}
                    />
                  </div>

                  <div className="inputs-box-2">
                    <label className="font-family-medium">
                      Отдел
                      <button className="font-family-medium text-white">
                        <span
                          onClick={() =>
                            history.push(
                              "/main/hr-admin/departments/departments-add"
                            )
                          }
                        >
                          Добавить новое
                        </span>
                      </button>
                    </label>
                    <Select
                      showSearch
                      placeholder="Поиск, чтобы выбрать"
                      optionFilterProp="children"
                      className="w-100"
                      onSearch={getDeps}
                      onChange={(e) =>
                        setSendData({ ...sendData, department_id: e })
                      }
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={departments?.map((item) => {
                        return {
                          value: item.id,
                          label: item.id + " " + item?.department_title,
                        };
                      })}
                    />
                  </div>
                  {/*<div className="inputs-box">*/}
                  {/*    <label  className="font-family-medium">Должность <button className="font-family-medium">Добавить новое</button></label>*/}
                  {/*       <Select*/}
                  {/*    className="w-100" */}
                  {/*    options={[*/}
                  {/*        { value: 'jack', label: 'Jack' },*/}
                  {/*        { value: '1', label: '1' },*/}
                  {/*        { value: 'Yiminghe', label: 'yiminghe' },*/}
                  {/*        { value: 'disabled', label: 'Disabled', disabled: true },*/}
                  {/*    ]}*/}
                  {/*/>*/}
                  {/*</div>*/}

                  {/*<div className="inputs-box">*/}
                  {/*    <label className="font-family-medium">Должность </label>*/}
                  {/*    <input type="text"*/}
                  {/*           onChange={(e) => setSendData({...sendData, position: e.target.value})}/>*/}
                  {/*</div>*/}
                  {/*<div className="inputs-box">*/}
                  {/*    <label  className="font-family-medium">Режим <button className="font-family-medium">Добавить новое</button> </label>*/}
                  {/*       <Select*/}
                  {/*    className="w-100" */}
                  {/*    options={[*/}
                  {/*        { value: 'jack', label: 'Jack' },*/}
                  {/*        { value: '1', label: '1' },*/}
                  {/*        { value: 'Yiminghe', label: 'yiminghe' },*/}
                  {/*        { value: 'disabled', label: 'Disabled', disabled: true },*/}
                  {/*    ]}*/}
                  {/*/>*/}
                  {/*</div>*/}

                  {/*<div className="inputs-box-2">*/}
                  {/*    <label className="font-family-medium">Роли</label>*/}
                  {/*    <Select*/}
                  {/*        showSearch*/}
                  {/*        placeholder="Поиск, чтобы выбрать"*/}
                  {/*        optionFilterProp="children"*/}
                  {/*        className="w-100"*/}
                  {/*        onSearch={getRoles}*/}
                  {/*        onChange={(e) => setSendData({...sendData, role_id: e})}*/}

                  {/*        filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                  {/*        filterSort={(optionA, optionB) =>*/}
                  {/*            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                  {/*        }*/}
                  {/*        options={roles?.map((item) => {*/}
                  {/*            return {*/}
                  {/*                value: item.id,*/}
                  {/*                label: item.id + " " +*/}
                  {/*                    item?.name*/}
                  {/*            };*/}
                  {/*        })}*/}
                  {/*    />*/}
                  {/*</div>*/}
                  {/*<div className="inputs-box-2">*/}
                  {/*    <label className="font-family-medium">Роли</label>*/}
                  {/*    <Select*/}
                  {/*        showSearch*/}
                  {/*        placeholder="Поиск, чтобы выбрать"*/}
                  {/*        optionFilterProp="children"*/}
                  {/*        className="w-100"*/}
                  {/*        onSearch={getRoles}*/}
                  {/*        onChange={(e) => setSendData({...sendData, role_id: e})}*/}

                  {/*        filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                  {/*        filterSort={(optionA, optionB) =>*/}
                  {/*            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                  {/*        }*/}
                  {/*        options={roles?.map((item) => {*/}
                  {/*            return {*/}
                  {/*                value: item.id,*/}
                  {/*                label: item.id + " " +*/}
                  {/*                    item?.name*/}
                  {/*            };*/}
                  {/*        })}*/}
                  {/*    />*/}
                  {/*</div>*/}

                  <div className="inputs-box-2">
                    <label className="font-family-medium">Режим</label>
                    <Select
                      showSearch
                      placeholder="Поиск, чтобы выбрать"
                      optionFilterProp="children"
                      className="w-100"
                      onSearch={getModes}
                      onChange={(e) =>
                        setSendData({
                          ...sendData,
                          employee_work_schedules_template_id: e,
                        })
                      }
                      value={sendData?.employee_work_schedules_template_id}
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={modes?.map((item) => {
                        return {
                          value: item.id,
                          label:
                            item.weekday_start +
                            "-" +
                            item.weekday_end +
                            " / " +
                            item?.shift_start_time?.slice(0, 5) +
                            "-" +
                            item?.shift_end_time?.slice(0, 5),
                        };
                      })}
                    />
                  </div>
                </div>
              </div>
              <div className="con-btn">
                <button className="font-family-medium" onClick={sendAll}>
                  <span>Подтверждать</span>
                </button>
                <button
                  className="font-family-medium ml-8"
                  onClick={() => history.goBack()}
                >
                  {/* test merge */}
                  Отменить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="my-loader">
          <Spin size="large" />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ProfileCreate;
